import React, { FC, useEffect, useState } from 'react';
import { styled, useTheme } from '@material-ui/core';
import { Icons, SvgIcon } from '../SvgIcon';
import { Tooltip } from '../Tooltip';
import { SwitchButton } from '../switch';

type ListItemToggleActionButtonProps = {
  icon: Icons;
  tooltip?: React.ReactNode | undefined;
  onChange: (newValue: boolean) => void;
  checked: boolean;
};

const IconButtonBase = styled('div')({
  position: 'relative',
  width: '2.4rem',
  height: '2.4rem',
  borderRadius: '100%',
  background: 'white',
  boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.15)',
  '& svg': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

const ListItemSwitchActionButton: FC<ListItemToggleActionButtonProps> = ({
  icon,
  tooltip,
  onChange,
  checked,
}) => {
  const theme = useTheme();
  const [checkedState, setCheckedState] = useState(checked);

  useEffect(() => {
    setCheckedState(checked);
  }, [checked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedState(event.target.checked);
    onChange(event.target.checked);
  };

  const iconComponent = (
    <IconButtonBase>
      <SvgIcon
        icon={icon}
        color={checkedState ? theme.palette.primary.main : theme.palette.grey['500']}
        small
      />
    </IconButtonBase>
  );

  return tooltip ? (
    <Tooltip title={tooltip} placement="left">
      <SwitchButton
        icon={iconComponent}
        checkedIcon={iconComponent}
        checked={checkedState}
        onChange={handleChange}
        color="primary"
      />
    </Tooltip>
  ) : (
    <SwitchButton
      icon={iconComponent}
      checkedIcon={iconComponent}
      checked={checkedState}
      onChange={handleChange}
      color="primary"
    />
  );
};

export default ListItemSwitchActionButton;
